import { useEffect, useState } from 'react';
import { motionDisabled } from '@/shared/lib/motion';

/**
 * פס מילוי שגדל מ-0 לערך (עיצוב v2: transition על width, easeOut). בשינוי
 * ערך הוא זז מהרוחב הנוכחי — לא מתאפס — כך שרענון לא מקפיץ.
 */
export function GrowBar({ pct, color = 'var(--accent)', height = 5, ms = 800, track = 'var(--surface-3)', label }: {
  pct: number; color?: string; height?: number; ms?: number; track?: string; label?: string;
}) {
  const target = Math.min(100, Math.max(0, pct));
  const [w, setW] = useState(() => (motionDisabled() ? target : 0));
  useEffect(() => {
    const raf = requestAnimationFrame(() => setW(target));
    return () => cancelAnimationFrame(raf);
  }, [target]);
  return (
    <span aria-hidden={label ? undefined : true} aria-label={label} style={{ display: 'block', flex: 1, height, borderRadius: 99, background: track, overflow: 'hidden' }}>
      <span style={{ display: 'block', height: '100%', borderRadius: 99, background: color, width: `${w}%`, transition: `width ${ms}ms var(--ease-out), background .3s ease` }} />
    </span>
  );
}
